import React, { JSX } from 'react';
import Icons from 'components/atoms/Icons';
import {
  OnQueryInputChangeType,
  UpdateQueryType,
} from 'components/types/FilterTypes';

type ClinicalTrialsSearchBarProps = {
  queryInputValue: string;
  onQueryInputChange: OnQueryInputChangeType;
  updateQuery: UpdateQueryType;
};

const ClinicalTrialsSearchBar = (
  props: ClinicalTrialsSearchBarProps
): JSX.Element => {
  const { queryInputValue, onQueryInputChange, updateQuery } = props;

  const submitSearch = () => {
    updateQuery(queryInputValue);
  };

  return (
    <div className="clinical-trials-search-bar-container">
      <div className="jss-inner-container">
        <div className="clinical-trials-search-bar">
          <div className="clinical-trials-search-input-wrap">
            <button
              type="button"
              className="clinical-trials-search-icon-btn"
              onClick={submitSearch}
              aria-label="Search clinical trials"
            >
              <Icons id="icon-search-green" className="icon-search" />
            </button>
            <input
              type="search"
              className="clinical-trials-search-input"
              placeholder="Search by Keyword"
              value={queryInputValue}
              onChange={e => onQueryInputChange(e.target.value)}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  submitSearch();
                }
              }}
              aria-label="Search by Keyword"
            />
            <button
              type="button"
              className="btn-primary no-icon clinical-trials-search-btn"
              onClick={submitSearch}
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClinicalTrialsSearchBar;
